import { memo } from 'react';

import styles from './home.module.scss';

export const HomePage = memo(() => (
  <div className={styles.root}>
    <h1>
      Tell me what you would like to see here <span>@Nazar Shvets</span>
    </h1>
  </div>
));
